import script from "./ShopManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopManage.vue?vue&type=script&setup=true&lang=js"

import "./ShopManage.vue?vue&type=style&index=0&id=509a82ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509a82ac"]])

export default __exports__